module.exports = __webpack_public_path__ + "palo-english-24b1596b0683dbcd8be3.svg";